import { defineStore } from 'pinia';

import {
  CompanyDetailResponse,
  CompanyRepository,
} from '@/repositories/generated';
import { toPostalCodeWithHyphen } from '@/utils';
import { CompanyEditForm } from '@/validations/company';

type TEditCompanyState = {
  form: CompanyEditForm | undefined;
  initData: CompanyDetailResponse | undefined;
};

export const useEditCompanyStore = defineStore('editCompany', {
  state: (): TEditCompanyState => ({
    form: undefined,
    initData: undefined,
  }),
  actions: {
    // eslint-disable-next-line complexity
    async editCompany() {
      const {
        form,
        initData,
      } = this;

      if (!(form && initData)) return;

      await CompanyRepository.edit({
        id: initData.id,
        requestBody: {
          ...form,
          name: form.companyName,
          nameKana: form.nameKana || null,
          nameRomaji: form.nameRomaji || null,
          merchantCategoryCode: form.merchantCategoryCode || null,
          postalCode: toPostalCodeWithHyphen(form.postalCode) ?? '',
          buildingName: form.buildingName || null,
          startsAt: form.startsAt.toISOString(),
          endsAt: form.endsAt?.toISOString() || null,
          customField1: form.customField1 || null,
          customField2: form.customField2 || null,
          customField3: form.customField3 || null,
          customField4: form.customField4 || null,
          customField5: form.customField5 || null,
          bankAccount: form.bankAccount && {
            bankCode: form.bankAccount.bankCode,
            bankBranchCode: form.bankAccount.bankBranchCode,
            bankAccountType: form.bankAccount.bankAccountType,
            bankAccountNumber: form.bankAccount.bankAccountNumber,
            bankAccountHolder: form.bankAccount.bankAccountHolder,
          },
          lastUpdatedAt: form.lastUpdatedAt,
          applyFromMonth: form.applyFromMonth || null,
          newCycleType: form.newCycleType === 'UNSELECTED'
            ? null
            : form.newCycleType?.toLowerCase() || null,
          remarks: form.remarks || null,
        },
      });
    },
    async setInitData(id: string) {
      this.$reset();

      const response = await CompanyRepository.detail({ id });
      this.initData = response;
    },
    setUiForm(form: CompanyEditForm) {
      this.form = {
        ...form,
        bankAccount: form.bankAccount && {
          ...form.bankAccount,
        },
      };
    },
    $resetForm() {
      this.form = undefined;
    },
  },
});
